/*
  SheetFlow — custom colour gallery + navigable lightbox
  ------------------------------------------------------------
  - Shows ONLY media matching the selected colour (untagged hidden).
  - One large active image + filtered thumbnail row; thumb click swaps.
  - Click big image → full-screen lightbox.
  - Lightbox: ‹ › arrows + ArrowLeft/Right keys cycle through the
    currently-visible (selected-colour) images. Esc / click bg / × closes.
*/
(function () {
  var COLOURS = ['Pastel', 'Ocean', 'Boho', 'Dark', 'Minimalist', 'Elegant'];
  var lbIndex = 0;
  var lbList = [];

  function gallery() { return document.querySelector('sf-gallery'); }
  function lightbox() { return document.querySelector('.sf-lightbox'); }

  function selectedColour() {
    var checked = document.querySelectorAll(
      '.sf-info input[type="radio"]:checked, .product-form__input--pill input[type="radio"]:checked, variant-selects input[type="radio"]:checked'
    );
    for (var i = 0; i < checked.length; i++) {
      if (COLOURS.indexOf(checked[i].value) > -1) return checked[i].value;
    }
    var sels = document.querySelectorAll('.sf-info select, variant-selects select');
    for (var s = 0; s < sels.length; s++) {
      var opt = sels[s].options[sels[s].selectedIndex];
      if (opt && COLOURS.indexOf(opt.value) > -1) return opt.value;
    }
    var g = gallery();
    if (g && COLOURS.indexOf(g.getAttribute('data-selected')) > -1) {
      return g.getAttribute('data-selected');
    }
    return COLOURS[0];
  }

  function setActive(g, mediaId) {
    g.querySelectorAll('.sf-g-slide').forEach(function (s) {
      s.classList.toggle('is-active', s.getAttribute('data-media-id') === mediaId);
    });
    g.querySelectorAll('.sf-g-thumb').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-target') === mediaId);
    });
  }

  function apply() {
    var g = gallery();
    if (!g) return;
    var colour = selectedColour();
    g.setAttribute('data-selected', colour);

    var firstId = null;
    g.querySelectorAll('.sf-g-slide').forEach(function (s) {
      var show = (s.getAttribute('data-sf-colour') || '') === colour;
      s.style.display = show ? '' : 'none';
      if (show && firstId === null) firstId = s.getAttribute('data-media-id');
    });
    g.querySelectorAll('.sf-g-thumb').forEach(function (t) {
      var show = (t.getAttribute('data-sf-colour') || '') === colour;
      t.style.display = show ? '' : 'none';
    });

    if (firstId === null) {
      g.querySelectorAll('.sf-g-slide').forEach(function (s, i) {
        s.style.display = '';
        if (i === 0) firstId = s.getAttribute('data-media-id');
      });
      g.querySelectorAll('.sf-g-thumb').forEach(function (t) { t.style.display = ''; });
    }
    if (firstId) setActive(g, firstId);
  }

  function visibleImages() {
    var g = gallery();
    return [].slice.call(g.querySelectorAll('.sf-g-slide')).filter(function (s) {
      // Only image slides go into the lightbox (skip videos / processing media).
      return s.style.display !== 'none' && s.querySelector('img');
    }).map(function (s) {
      var img = s.querySelector('img');
      return { src: img ? img.src : '', alt: img ? img.alt : '', id: s.getAttribute('data-media-id') };
    });
  }

  function showLbAt(i) {
    var lb = lightbox();
    if (!lb || !lbList.length) return;
    lbIndex = (i + lbList.length) % lbList.length;
    var item = lbList[lbIndex];
    lb.querySelector('.sf-lb-img').src = item.src;
    lb.querySelector('.sf-lb-img').alt = item.alt;
  }

  function openLightbox(mediaId) {
    var lb = lightbox();
    if (!lb) return;
    lbList = visibleImages();
    var idx = 0;
    for (var i = 0; i < lbList.length; i++) { if (lbList[i].id === mediaId) { idx = i; break; } }
    showLbAt(idx);
    lb.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    var lb = lightbox();
    if (!lb) return;
    lb.hidden = true;
    document.body.style.overflow = '';
  }

  function wire() {
    var g = gallery();
    if (g && !g.__sfWired) {
      g.__sfWired = true;
      g.addEventListener('click', function (e) {
        var thumb = e.target.closest ? e.target.closest('.sf-g-thumb') : null;
        if (thumb) { e.preventDefault(); setActive(g, thumb.getAttribute('data-target')); return; }
        var slide = e.target.closest ? e.target.closest('.sf-g-slide.is-active') : null;
        if (slide && e.target.tagName === 'IMG') { openLightbox(slide.getAttribute('data-media-id')); }
      });
    }
    var lb = lightbox();
    if (lb && !lb.__sfWired) {
      lb.__sfWired = true;
      lb.addEventListener('click', function (e) {
        var t = e.target;
        if (t === lb || (t.classList && t.classList.contains('sf-lb-close'))) { closeLightbox(); return; }
        if (t.classList && t.classList.contains('sf-lb-prev')) { showLbAt(lbIndex - 1); return; }
        if (t.classList && t.classList.contains('sf-lb-next')) { showLbAt(lbIndex + 1); return; }
      });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') closeLightbox();
        else if (e.key === 'ArrowLeft') showLbAt(lbIndex - 1);
        else if (e.key === 'ArrowRight') showLbAt(lbIndex + 1);
      });
    }
  }

  // Reorder media so every colour group follows the SAME sequence.
  // The image filename starts with the intended order number (1.png, 3.png …),
  // so sort each colour group by that number ascending. Keeps colour groups in
  // first-appearance order. Robust regardless of how media are ordered in admin.
  function fileNum(el) {
    // Order within a colour: cover (1) → video → rest (3,4,5…).
    // Images are numbered 1,3,4,5… (no "2"), so video takes the empty "2" slot.
    var mt = el.getAttribute('data-media-type');
    if (mt && mt !== 'image') return 2;
    var img = el.querySelector('img');
    var src = img ? (img.getAttribute('src') || '') : '';
    var name = src.split('?')[0].split('/').pop() || '';
    var m = name.match(/(\d+)/);
    return m ? parseInt(m[1], 10) : 9999;
  }
  function sortGallery(g) {
    function order(container, sel) {
      if (!container) return;
      var els = [].slice.call(container.querySelectorAll(sel));
      var groups = [], map = {};
      els.forEach(function (el) {
        var c = el.getAttribute('data-sf-colour') || '';
        if (!map[c]) { map[c] = []; groups.push(c); }
        map[c].push(el);
      });
      groups.forEach(function (c) {
        map[c].sort(function (a, b) { return fileNum(a) - fileNum(b); });
        map[c].forEach(function (el) { container.appendChild(el); });
      });
    }
    order(g.querySelector('.sf-g-main'), '.sf-g-slide');
    order(g.querySelector('.sf-g-thumbs'), '.sf-g-thumb');
  }

  function init() {
    var g = gallery();
    if (g) sortGallery(g);
    apply();
    wire();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[type="radio"], select')) {
      apply();
      setTimeout(apply, 200);
    }
  });
  document.addEventListener('variant:update', function () { setTimeout(apply, 60); });
})();